// Activity type configuration and labels
export const activityTypes = [
  { value: 'meeting', label: 'Reunión' },
  { value: 'call', label: 'Llamada' },
  { value: 'email', label: 'Email' },
  { value: 'reflexion', label: 'Reflexión' },
  { value: 'evento', label: 'Evento' }
];

export const typeLabels = { 
  meeting: 'Reunión', 
  call: 'Llamada', 
  email: 'Email',
  reflexion: 'Reflexión',
  evento: 'Evento'
};

export const companyCategories = [
  { value: 'typsa', label: 'TYPSA' },
  { value: 'publica', label: 'Pública' },
  { value: 'privada', label: 'Privada' }
];

export const typsaOrgCategories = [
  { value: 'division', label: 'División' },
  { value: 'departamento', label: 'Departamento' },
  { value: 'territorio', label: 'Territorio' },
  { value: 'grupo', label: 'Grupo' }
];

// Dynamic fields configuration per activity type
export const typeFields = {
  meeting: {
    label: 'Minutes of Meeting',
    fields: ['key_points', 'decisions', 'next_steps', 'risks', 'opportunities', 'transcript']
  },
  call: {
    label: 'Registro de Llamada',
    fields: ['key_points', 'next_steps', 'transcript']
  },
  email: {
    label: 'Registro de Email',
    fields: ['key_points', 'message_content']
  },
  reflexion: {
    label: 'Reflexión',
    fields: ['key_points', 'opportunity_detected', 'internal_notes']
  },
  evento: {
    label: 'Evento',
    fields: ['event_description']
  }
};

export const fieldLabels = {
  key_points: 'Puntos clave',
  decisions: 'Decisiones',
  next_steps: 'Próximos pasos',
  risks: 'Riesgos',
  opportunities: 'Oportunidades',
  transcript: 'Transcripción / Detalle',
  message_content: 'Contenido del mensaje',
  opportunity_detected: 'Oportunidad detectada',
  internal_notes: 'Notas internas',
  event_description: 'Descripción del evento'
};

export const fieldPlaceholders = {
  key_points: 'Lista los puntos más importantes...',
  decisions: 'Decisiones tomadas durante la actividad...',
  next_steps: 'Acciones a realizar después...',
  risks: 'Riesgos o preocupaciones identificados...',
  opportunities: 'Oportunidades detectadas...',
  transcript: 'Transcripción o notas detalladas...',
  message_content: 'Contenido o resumen del email...',
  opportunity_detected: 'Describe la oportunidad identificada...',
  internal_notes: 'Notas personales o internas...',
  event_description: 'Describe qué ocurrió...'
};
